import {
    useEffect,
    useLayoutEffect,
    useRef,
    useState
} from 'react'

import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import {
    Link,
    useLocation
} from 'react-router-dom'
import styled from 'styled-components'

import * as spriteIcons from 'assets/svg/sprite'
import { NewPostPopupDesktop } from 'components-ref/molecules'
import { AllIcons } from 'helpers/allIcons'
import { useAccessToken, useUserProfile } from 'store'
import { usePendingNotificationsStore } from 'store/pendingNotificationsStore'
import colors from 'styles/colors'
import screens from 'styles/screens'
type PopupPosition = {
    top: number
    left: number
}

function SidebarNavigation() {
    const { t } = useTranslation()
    const userData = useUserProfile()
    const isAuthenticated = useAccessToken() !== ''

    const openGuestLogin = () => {
    window.dispatchEvent(new Event('open-guest-login'))
    }

    const handleGuestNavigation = (
    event: React.MouseEvent<HTMLAnchorElement>
    ) => {
    if (isAuthenticated) return

    event.preventDefault()
    openGuestLogin()
    }
    const newPostButtonRef = useRef<HTMLLIElement>(null)
    const [newPostOpen, setNewPostOpen] = useState(false)
    const [morePanelOpen, setMorePanelOpen] = useState(false)

    const messagesCount =
        usePendingNotificationsStore(s => s.messages)

    const sidebarRef = useRef<HTMLUListElement>(null)
    const morePanelRef = useRef<HTMLDivElement | null>(null)
    const moreButtonRef = useRef<HTMLButtonElement | null>(null)
    const [morePanelPosition, setMorePanelPosition] = useState({
        top: 0,
        left: 0,
        height: 0
    })

    const location = useLocation()
        const [popupPosition, setPopupPosition] = useState<PopupPosition>({
            top: 0,
            left: 0
        })




    const navItemsModels = [
        {
            icon: <spriteIcons.IconNoteCurvy />,
            label: t('profile'),
            link: `/${userData?.username}`,
            absfix: true
        },
        {
            icon: <spriteIcons.IconChatBubble />,
            label: t('messages'),
            link: '/chat',
            absfix: true,
            showMessageCount: true
        },
        {
            icon: <spriteIcons.IconDollarCircleNoFill />,
            label: t('earnings'),
            link: '/earnings/sales',
            absfix: true
        },
        {
            icon: <spriteIcons.IconAnalytics />,
            label: t('analytics'),
            link: '/analytics/sales',
            absfix: true
        },
        {
            icon: <spriteIcons.IconPictureSymbol />,
            label: t('sharedMedia'),
            link: '/vault',
            absfix: true
        },
        {
            icon: <spriteIcons.IconThreePeople />,
            label: t('Fans'),
            link: '/fans',
            absfix: true
        },
        {
            icon: <spriteIcons.IconCalendarLarge />,
            label: t('schedule'),
            link: '/schedule',
            absfix: true
        },
        {
            icon: <spriteIcons.IconMediaFolder2 />,
            label: t('mediaCategories'),
            link: '/media_categories',
            absfix: true
        },
        ...(Number(userData?.overall_revenue) > 200
            ? [
                  {
                      icon: <spriteIcons.IconPeopleHeart />,
                      label: t('friends'),
                      link: '/friends',
                      absfix: true
                  } as const
              ]
            : []),
        {
            icon: <spriteIcons.IconNoteCurvy />,
            label: t('following'),
            link: '/following',
            absfix: true
        },
        {
            icon: <spriteIcons.IconMediaFolder2 />,
            label: t('reels'),
            link: '/discover/reels'
        },
        {
            icon: <spriteIcons.IconMediaFolder />,
            label: t('media'),
            link: '/media',
            absfix: true
        },
        {
            icon: <spriteIcons.IconSettings />,
            label: t('settings'),
            link: '/settings/general',
            absfix: true
        },
        {
            icon: <spriteIcons.IconLiveStream />,
            label: t('streamArchives'),
            link: '/streams',
            absfix: true,
            disabled: true
        },
        {
            icon: <spriteIcons.IconSearchBlue />,
            label: t('browseCreators'),
            link: '/creators',
            absfix: true
        },
        {
            icon: <spriteIcons.IconTwoPeople />,
            label: 'Subscriptions',
            link: '/subscriptions',
            absfix: true
        },
        {
            icon: <spriteIcons.IconCreditCards />,
            label: 'Manage Cards',
            link: '/settings/general/wallet',
            absfix: true
        },
        {
            icon: <spriteIcons.IconDollarCircleArrows />,
            label: t('transactions'),
            link: '/transactions',
            absfix: true
        },
/*         {
            icon: <spriteIcons.IconHowToBook />,
            label: t('howToTutorials'),
            link: '/how-to/tutorials',
            absfix: true
        }, */
        {
            icon: <spriteIcons.IconManHeadphones />,
            label: t('support'),
            link: '/support/home',
            absfix: true
        },
        {
            icon: <spriteIcons.IconManHeadphones />,
            label: 'Terms & Policies',
            link: '/termsandpolicies',
            absfix: true
        }
    ]

    const navItemsFans = [
        {
            icon: <spriteIcons.IconNoteCurvy />,
            label: t('feed'),
            link: '/following',
        },
        {
            icon: <spriteIcons.IconChatBubble />,
            label: t('messages'),
            link: '/chat',
            absfix: true,
            showMessageCount: true
        },
        {
            icon: <spriteIcons.IconSearchBlue />,
            label: t('browseCreators'),
            link: '/creators'
        },
        {
            icon: <spriteIcons.IconMediaFolder2 />,
            label: t('reels'),
            link: '/discover/reels'
        },
        {
            icon: <spriteIcons.IconMediaFolder2 />,
            label: t('media'),
            link: '/media'
        },
        {
            icon: <spriteIcons.IconTwoPeople />,
            label: t('subscriptions'),
            link: '/subscriptions'
        },
        {
            icon: <spriteIcons.IconDollarCircleArrows />,
            label: t('transactions'),
            link: '/transactions'
        },
        {
            icon: <spriteIcons.IconCreditCards />,
            label: t('wallet'),
            link: '/settings/general/wallet'
        },
        {
            icon: <spriteIcons.IconBecomeCreator />,
            label: 'Become A Creator',
            link: '/become-a-creator'
        },
        {
            icon: <spriteIcons.IconSettings />,
            label: t('settings'),
            link: '/settings/general'
        },
/*         {
            icon: <spriteIcons.IconHowToBook />,
            label: t('howToFaq'),
            link: '/how-to/tutorials'
        }, */
        {
            icon: <spriteIcons.IconManHeadphones />,
            label: t('support'),
            link: '/support/home'
        },
        {
            icon: <spriteIcons.IconManHeadphones />,
            label: 'Terms & Policies',
            link: '/termsandpolicies',
            absfix: true
        }
    ]

    const navItems = userData?.role === 'model' ? navItemsModels : navItemsFans
    const settingsIndex = navItems.findIndex(
        item => item.link === '/settings/general'
    )

    const visibleNavItems =
        settingsIndex >= 0
            ? navItems.slice(0, settingsIndex + 1)
            : navItems

    const moreNavItems =
        settingsIndex >= 0
            ? navItems.slice(settingsIndex + 1)
            : []

    const hasHiddenItems = moreNavItems.length > 0

    const updatePopupPosition = () => {
        const button = newPostButtonRef.current
        if (!button) return

        const rect = button.getBoundingClientRect()

        setPopupPosition({
            top: rect.top,
            left: rect.right + 12
        })
    }

    function toggleNewPostPopup() {
        if (!newPostOpen) {
            updatePopupPosition()
        }
        setNewPostOpen(prev => !prev)
    }

    useLayoutEffect(() => {
        if (!newPostOpen) return

        const handleReposition = () => {
            updatePopupPosition()
        }

        updatePopupPosition()

        window.addEventListener('resize', handleReposition)
        window.addEventListener('scroll', handleReposition, true)

        return () => {
            window.removeEventListener('resize', handleReposition)
            window.removeEventListener('scroll', handleReposition, true)
        }
    }, [newPostOpen])
const updateMorePanelPosition = () => {
    const sidebar = sidebarRef.current

    if (!sidebar) return

    const rect = sidebar.getBoundingClientRect()

    setMorePanelPosition({
        top: rect.top,
        left: rect.right,
        height: rect.height
    })
}

const openMorePanel = () => {
    updateMorePanelPosition()
    setMorePanelOpen(true)
}

const closeMorePanel = () => {
    setMorePanelOpen(false)
}

useLayoutEffect(() => {
    if (!morePanelOpen) return

    const reposition = () => {
        updateMorePanelPosition()
    }

    reposition()

    window.addEventListener('resize', reposition)

    return () => {
        window.removeEventListener('resize', reposition)
    }
}, [morePanelOpen])
useEffect(() => {
  if (!morePanelOpen) return

  const handleDocumentClick = (event: MouseEvent) => {
    const target = event.target as Node

    if (morePanelRef.current?.contains(target)) {
      return
    }

    if (moreButtonRef.current?.contains(target)) {
      return
    }

    setMorePanelOpen(false)
  }

  document.addEventListener(
    'click',
    handleDocumentClick
  )

  return () => {
    document.removeEventListener(
      'click',
      handleDocumentClick
    )
  }
}, [morePanelOpen])
useEffect(() => {
    if (!morePanelOpen) return

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            closeMorePanel()
        }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
        window.removeEventListener('keydown', handleKeyDown)
    }
}, [morePanelOpen])
    return (
        <>
        {createPortal(
            <PopupLayer $open={newPostOpen}>
                <PopupPositioner
                    style={{
                        top: `${popupPosition.top}px`,
                        left: `${popupPosition.left}px`
                    }}
                >
                    <NewPostPopupDesktop
                        refButton={newPostButtonRef}
                        setIsOpen={setNewPostOpen}
                        isOpen={newPostOpen}
                    />
                </PopupPositioner>
            </PopupLayer>,
            document.body
        )}

                <SidebarContainer
                    ref={sidebarRef}
                    $isFan={userData?.role !== 'model'}
                >
                    {userData?.role === 'model' && (
                        <NewPost
                            ref={newPostButtonRef}
                            onClick={toggleNewPostPopup}
                            $active={newPostOpen}
                        >
                            <PlusSignWrapper $active={newPostOpen}>
                                <PlusSign $active={newPostOpen}>
                                    <img
                                        src={AllIcons.footer_addpost}
                                        alt='Add post'
                                    />
                                </PlusSign>
                            </PlusSignWrapper>

                            New Post
                        </NewPost>
                    )}

                {visibleNavItems.map((item, i) => (
                    <SidebarItem
                        key={`${item.link}-${i}`}
                        $active={item.link === location.pathname}
                    >
                        <Link
                        to={item.link}
                        onClick={handleGuestNavigation}
                        >
                            {item.icon}

                            <span>
                                {t(item.label)}
                            </span>

                            {'showMessageCount' in item &&
                                item.showMessageCount &&
                                messagesCount > 0 && (
                                    <SidebarCounter>
                                        {messagesCount}
                                    </SidebarCounter>
                                )}
                        </Link>
                    </SidebarItem>
                ))}

    {hasHiddenItems && (
        <SidebarItem $active={morePanelOpen}>
            <button
                ref={moreButtonRef}
                type='button'
                onClick={() => {
                    if (morePanelOpen) {
                        closeMorePanel()
                    } else {
                        openMorePanel()
                    }
                }}
            >
                <div className='more-icon'>
                    <spriteIcons.IconThreeDotsCircle />
                </div>

                {t('more')}
            </button>
        </SidebarItem>
    )}
</SidebarContainer>
{morePanelOpen &&
    createPortal(
        <MorePanel
            ref={morePanelRef}
            style={{
                top: `${morePanelPosition.top}px`,
                left: `${morePanelPosition.left}px`,
                height: `${morePanelPosition.height}px`
            }}
        >
            <MorePanelHeader>
                <span>More</span>

                <MorePanelClose
                    type='button'
                    onClick={closeMorePanel}
                    aria-label='Close'
                >
                    ×
                </MorePanelClose>
            </MorePanelHeader>

            <MorePanelItems>
                {moreNavItems.map((item, i) => {
                    const disabled = 'disabled' in item && item.disabled

                    return (
                        <MorePanelItem
                            key={`${item.link}-${i}`}
                            $active={!disabled && item.link === location.pathname}
                            $disabled={disabled}
                        >
                            {disabled ? (
                                <div className='more-panel-link'>
                                    <span className={`more-panel-icon ${
                                        item.absfix ? 'more-panel-icon--absfix' : ''
                                    }`}>
                                        {item.icon}
                                    </span>

                                    <span>{t(item.label)}</span>
                                </div>
                            ) : (
                                <Link
                                to={item.link}
                                onClick={event => {
                                    closeMorePanel()
                                    handleGuestNavigation(event)
                                }}
                                >
                                    <span className={`more-panel-icon ${
                                        item.absfix ? 'more-panel-icon--absfix' : ''
                                    }`}>
                                        {item.icon}
                                    </span>

                                    <span>{t(item.label)}</span>
                                </Link>
                            )}
                        </MorePanelItem>
                    )
                })}
            </MorePanelItems>
        </MorePanel>,
        document.body
    )}
        </>
    )
}

export default SidebarNavigation

const PopupLayer = styled.div<{ $open: boolean }>`
    position: fixed;
    inset: 0;
    z-index: 999999;

    opacity: ${props => (props.$open ? 1 : 0)};
    visibility: ${props => (props.$open ? 'visible' : 'hidden')};
    pointer-events: ${props => (props.$open ? 'none' : 'none')};
`

const MorePanel = styled.div`
    position: fixed;
    z-index: 99991;

    width: 25rem;
    min-width: 25rem;

    background: ${colors.white};

    border-radius: 0 2.5rem 2.5rem 0;

    box-shadow: 2rem 0 3rem -1.5rem rgba(17, 29, 41, 0.18);

    overflow: hidden;

    display: flex;
    flex-direction: column;

    animation: morePanelSlideIn 180ms
        cubic-bezier(0.22, 1, 0.36, 1);

    @keyframes morePanelSlideIn {
        from {
            opacity: 0;
            transform: translateX(-1.5rem);
        }

        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    @media (max-width: ${screens.medium}) {
        display: none;
    }
`

const MorePanelHeader = styled.div`
    height: 7.5rem;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 0 2.5rem;

    font-family: Montserrat;
    font-size: 1.8rem;
    font-weight: 600;

    color: ${colors.black};

    flex-shrink: 0;

    > * {
        transform: translateY(0.5rem);
    }
`

const MorePanelClose = styled.button`
    width: 4rem;
    height: 4rem;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 0;
    padding: 0;

    background: transparent;

    color: #828c94;

    font-family: Arial, sans-serif;
    font-size: 3.2rem;
    font-weight: 200;
    line-height: 1;

    cursor: pointer;

    transition:
        background 150ms,
        color 150ms;

    border-radius: 50%;

    &:hover {
        background: ${colors.whiteSmoke};
        color: ${colors.black};
    }
`

const MorePanelItems = styled.ul`
    margin: 0;
    padding: 0 1.5rem 2rem;

    list-style: none;

    display: flex;
    flex-direction: column;
`

const MorePanelItem = styled.li<{
    $active?: boolean
    $disabled?: boolean
}>`
    width: 100%;
    border-radius: 2.5rem;

    color: ${props =>
        props.$disabled
            ? '#c2c6ca'
            : props.$active
                ? colors.blueLighter
                : colors.black};

    transition: background 150ms;

    a,
    .more-panel-link {
        width: 100%;
        min-height: 5.5rem;
        display: flex;
        align-items: center;
        gap: 1.5rem;
        padding: 0 1.5rem;
        box-sizing: border-box;
        color: inherit;
        font-family: Montserrat;
        font-size: 1.5rem;
        font-weight: 500;
        text-decoration: none;
    }

    .more-panel-link {
        cursor: default;
        user-select: none;
    }

    .more-panel-icon {
        width: 3.5rem;
        min-width: 3.5rem;
        height: 3.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        svg {
            width: 2.8rem;
            height: 2.8rem;
            max-width: 2.8rem;
            max-height: 2.8rem;

            filter: ${props =>
                props.$disabled
                    ? 'grayscale(100%) opacity(45%)'
                    : `grayscale(${props.$active ? 0 : 100}%)`};
        }
    }

    .more-panel-icon--absfix svg {
        transform: translateY(18%);
    }

    &:hover {
        background: ${props =>
            props.$disabled ? 'transparent' : colors.whiteSmoke};
    }
`

const PopupPositioner = styled.div`
    position: fixed;
    pointer-events: auto;
    transform: translateY(-12px);
`

const SidebarContainer = styled.ul<{ $isFan?: boolean }>`
    position: relative;
    overflow: auto;

    &::-webkit-scrollbar {
        width: 0;
    }

    background-color: ${colors.white};
    margin-right: 7rem;
    height: 100%;
    margin-top: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    padding-top: ${props => (props.$isFan ? '2rem' : '0')};

@media (max-width: ${screens.medium}) {
    display: none;
}
`
const SidebarItem = styled.li<{ $active?: boolean }>`
    height: 5rem;
    width: 23.5rem;
    display: flex;
    align-items: center;
    border-radius: 3rem;
    padding: 0.5rem 1rem;
    min-width: 22rem;
    gap: 0.5rem;
    transition: all 150ms;
    color: ${props => (props.$active ? colors.blueLighter : colors.black)};

    .more-icon {
        width: 5rem;
        min-width: 5rem;
        height: 5rem;

        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            filter: grayscale(${props => (props.$active ? 0 : 100)});
            transform: scale(0.8);
        }
    }

    a > svg,
    button > svg {
        filter: grayscale(${props => (props.$active ? 0 : 100)});
        transform: translateY(18%) scale(0.8);
    }
    .iconTwoPeopleWrap svg {
        filter: grayscale(${props => (props.$active ? 0 : 100)});
    }
        .iconTwoPeopleWrap {
        width: 5rem;
        min-width: 5rem;
        height: 5rem;

        display: flex;
        align-items: center;
        justify-content: center;

        transform: translateY(18%) scale(0.8);
    }
    a,
    button {
        font-family: Montserrat;
        font-size: 1.6rem;
        font-weight: 500;
        line-height: 2rem;
        letter-spacing: 0em;
        text-align: left;
        text-decoration: none;
        text-decoration-line: none;
        display: flex;
        align-items: center;
        gap: 1.5rem;
        width: 100%;
        cursor: pointer;
        background: transparent;
        border: 0;
        padding: 0;
        color: inherit;
    }

    &:hover {
        background-color: ${colors.whiteSmoke};
    }

    a:focus,
    button:focus {
        outline: none;
    }

    a:focus-visible,
    button:focus-visible {
        outline: none;
        text-decoration: underline;
        text-underline-offset: 0.5rem;
        text-decoration-thickness: 0.2rem;
    }
`
interface NewPostProps {
    $active: boolean
}

const NewPost = styled(SidebarItem)<NewPostProps>`
    transition: none;

    background-color: ${colors.black};
    color: ${colors.white};

    margin-bottom: 1.5rem;
    margin-top: 2rem;
    cursor: pointer;
    font-family: Montserrat;
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0em;
    text-align: left;
    text-decoration: none;
    text-decoration-line: none;
    outline: none;
    -webkit-tap-highlight-color: transparent;
    user-select: none;

    &:hover {
        background-color: ${colors.black};
        color: ${colors.white};
    }
`
const PlusSignWrapper = styled.span<{ $active: boolean }>`
    margin-right: 1.5rem;
    margin-left: 1rem;
    display: flex;

    border: solid 0.15rem #515355;
    border-radius: 10rem;
`

const PlusSign = styled.span<NewPostProps>`
    background-color: ${colors.white};
    border-radius: 10rem;
    width: 3rem;
    height: 3rem;
    border: solid 0.15rem ${colors.black};

    display: flex;
    flex-grow: 0;
    justify-content: center;
    align-items: center;

    img {
        filter: brightness(0);
        transition: transform 200ms ease;
        transform: ${props =>
            props.$active ? 'rotate(45deg)' : 'rotate(0deg)'};
    }
`
const SidebarCounter = styled.span`
margin-left: 0rem;
    min-width: 1.8rem;
    height: 1.8rem;

    padding: 0 0.45rem;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 10rem;

    background: ${colors.blueLighter};
    color: ${colors.white};

    font-family: Montserrat;
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1;

    box-sizing: border-box;
`